// src/components/BackgroundLayer/BackgroundLayer.tsx
import React from 'react';
import { useBackground } from '../../contexts/BackgroundContext';
import styles from './BackgroundLayer.module.css';

type Props = { target: 'main' | 'side' };

const BackgroundLayer: React.FC<Props> = ({ target }) => {
  const { main, side } = useBackground();
  const bg = target === 'main' ? main : side;

  if (bg.type === 'none' || !bg.url) return null;

  return (
    <div className={styles.layer} aria-hidden>
      {bg.type === 'image' ? (
        <img
          src={bg.url}
          alt=""
          className={styles.media}
          loading="lazy"
          decoding="async"
          onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
      ) : (
        <video
          className={styles.media}
          src={bg.url}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          onError={(e) => { (e.currentTarget as HTMLVideoElement).style.display = 'none'; }}
        />
      )}
      <div className={styles.vignette} />
    </div>
  );
};

export default BackgroundLayer;
